module.exports = __webpack_public_path__ + "129f6a8ca1a29709762dcbbcdc23fb4a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/seagulls.svg
// module id = 3
// module chunks = 0